<template>
  <div>
    <v-select
      v-model="selectedCameraEvents"
      :items="projectCameras"
      dense
      outlined
      :solo="solo"
      clearable
      label="Filter by camera"
      hide-details
      item-value="exid"
      item-text="name"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import { AdminApi } from "@evercam/shared/api/adminApi"
export default {
  name: "ProjectCameraSelect",
  props: {
    projectId: {
      type: [String, Number],
      required: true,
    },
    solo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedCameraEvents: [],
      projectCameras: [],
    }
  },
  async mounted() {
    await this.fetchProjectCameras()
  },
  methods: {
    async fetchProjectCameras() {
      if (!this.projectId) {
        return
      }
      try {
        const { data } = await AdminApi.projects.getCameras(this.projectId)

        this.projectCameras = data
      } catch (error) {
        this.$notifications.error({
          text: this.$t("content.fetch_resource_failed", {
            resource: "project cameras",
          }),
          error,
        })
      }
    },
  },
}
</script>
